<!-- 展示计划外 -->
<script setup>
import { ref, reactive, watch , computed,toRefs } from "vue";

import { useCrfStore } from "@/stores/crf";
import TGJC from "@/components/TGJC.vue";
import BS from "@/components/BS.vue";
import YBXX from "@/components/YBXX.vue";
import FSXX from "@/components/FSXX.vue";
import XCGJNCG from "@/components/XCGJNCG.vue";
import NXGN from "@/components/NXGN.vue";
import XSHJC from "@/components/XSHJC.vue";
import AFP from "@/components/AFP.vue";
import YGHCVHIV from "@/components/YGHCVHIV.vue";
import ANAANCA from "@/components/ANAANCA.vue";
import MYQDB from "@/components/MYQDB.vue";
import JZXGN from "@/components/JZXGN.vue";
import XDT from "@/components/XDT.vue";
import WJ from "@/components/WJ.vue";
import FIBROSCAN from "@/components/FIBROSCAN.vue";
import FIBROTOUCH from "@/components/FIBROTOUCH.vue";
import FBFSMJMBC from "@/components/FBFSMJMBC.vue";
import FBCT from "@/components/FBCT.vue";
import MJMCTV from "@/components/MJMCTV.vue";
import GZZQMR from "@/components/GZZQMR.vue";
import MRCP from "@/components/MRCP.vue";
import HVPGCD from "@/components/HVPGCD.vue";
import BFXY from "@/components/BFXY.vue";
import QTBSZL from "@/components/QTBSZL.vue";
import JWTIPSZL from "@/components/JWTIPSZL.vue";
import JWWKSSZL from "@/components/JWWKSSZL.vue";
import JWNJZL from "@/components/JWNJZL.vue";
import JWYWZL from "@/components/JWYWZL.vue";
import GZSDC from "@/components/GZSDC.vue";
import QWXZJYCX from "@/components/QWXZJYCX.vue";
import BLSJJL from "@/components/BLSJJL.vue";
import GZZQCT from  "@/components/GZZQCT.vue";
import BLBG from  "@/components/BLBG.vue";

import { useUserStore } from '../stores/user'
import { ElMessage } from "element-plus"
import { useCommonStore } from "@/stores/common";


// const emits = defineEmits(["update"]);
const emits = defineEmits([, "close", "update"]);

const props = defineProps({
    id:'',
    crf:{}

});
console.log(props,'props')
const crf = reactive(props.crf)
console.log(crf,"传过来的对象");
// 拿到医生id
const userId = useUserStore()
console.log(userId.id,"id");

// const crfStore = useCrfStore();
let module =crf.module ;

// 提交上传中提示
let crfLoading = ref(false)

// 通过医生的id和患者的id拿到患者所有数据

const model = reactive({
    user_id:userId.id,
    id: props.id,
    fields: {},
    checkdata:{},

})

let date = ref('')

 // 正常点击和跳转都需要请求(患者最新的数据)
 const commonStore = useCommonStore();
    commonStore.getData(props.id).then((res) => {
      console.log(res.data,"crf往下传递的数据");
      model.id = res.data.id;
      model.fields = res.data.fields;
      date.value = model.fields[crf.name].访视日期
         // 添加一下质疑的信息（设置默认值
      
      model.checkdata.ischeck ='是';
      // debugger
      setctps()
      console.log(date.value,"date");

    });
// 选择的访视日期
// let date = ref('')


// type  第几个计划外访视

let type = ref(crf.type)

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
    // date?model.fields[`计划外${date}`]['访视日期'] = date:''

  return model.fields[crf.name] || {}
});


let componentsShow = ref(true)
// watch(date,(newval,oldval)=>{
//     // model.fields[`计划外${date.value}`]?model.fields[`计划外${date.value}`]['访视日期'] = '' : '';
//     model.fields[`计划外${date.value}`]?.['访视日期']? model.fields[`计划外${date.value}`]['访视日期'] = newval :model.fields[`计划外${date.value}`] = {'访视日期' : newval}
   
//     type.value = `计划外${date.value}`
//     console.log(newval)
//     // 清空上个日期选择的值
//     emits('renewdate',newval)
//     // 所有组件重新加载，
//     componentsShow.value = false
//     componentsShow.value = true


// })

const formRule = reactive({});
let IdCard = ref()
 
  
 // 提交表单
 const submitForm = async () => {
  // 验证手机号
 if(!IdCard.value.phonefun()) return
  // 验证手机号
  if(!IdCard.value.phonefun()) return
  console.log(111111111)
    const store = useCrfStore();
      // 应该拿到网上的全的数据，而不应该从本地拿（吃完饭回来改）

    // 所有的访视期和计划外
    //  crfStore.forms.push({
    //     module:[...module.module],
    //     name: '计划外'+date.value,
    //     type: '计划外'+date.value,
    //  });
    //  jhw.push({
    //   module:[...module.module],
    //     name: '计划外'+date.value,
    //     type: '计划外'+date.value,
    //  })
    // console.log(jhw,"结构")
    // return
    //  model.fields.tabtitle = crfStore.forms
    // model.fields.jhw = jhw
    crfLoading.value = true 

    //  console.log(1111)
    let res = await store.update(model)
    // 请求返回结果就关闭上传提示
    crfLoading.value = false 
    if (res.result != "success"){
        console.log(2222);
        

        return ElMessage.error('提交失败！')

    } 

    // console.log(3333)
    // 在主页面刷新数据
    emits("update");
        // console.log(show,"看是几");
    // 提交完成关闭弹窗
    // planoutside.planDialog = false
}
const handleCloseDrawer = ()=>{
  emits('close')
}

const computedCtp = ref(null)
const Ctpitem = ref([])
const ctpMissing = ref([])
//ctp展示
let isctpshow = ref(false)
let ismeldshow = ref(false)

//缺失项
let missKey = ref([])
const meldMissing = ref([]) // MELD缺失项
const Melditem = ref([]) // MELD有效项
//computedMeld展示
const computedMeld = ref(null)
//ctp评分
const setctps = ()=>{
  //ctp
  // 清空之前的数据
  Ctpitem.value = []
  missKey.value = []
  ctpMissing.value = []
  
  let sum = 0
  let ctp = model.fields['计划外' + date.value]?.ctp
  let hasInvalidCtp = false
  
  // 固定的5个CTP指标
  const ctpKeys = ['腹水', '肝性脑病', '血清白蛋白', '血清胆红素', 'INR']
  
  // 检查 ctp 对象是否存在
  if(!ctp || Object.keys(ctp).length === 0){
    computedCtp.value = null
    // 完全无数据时，每一项都显示"无效数据(由于缺项无法计算当前评分)"
    for (const key of ctpKeys) {
      ctpMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
    }
  } else {
    // CTP对象存在，按固定顺序处理5个指标
    for (const key of ctpKeys) {
      // 检查该指标是否存在
      if (ctp[key] === undefined) {
        // 不存在的指标显示无效数据
        ctpMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
        hasInvalidCtp = true
        continue
      }
      
      // 检查是否可以转换为有效数字
      let ctpValue = Number(ctp[key])
      if(isNaN(ctpValue) || !isFinite(ctpValue)){
        hasInvalidCtp = true
        ctpMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
      } else {
        // 有效数据，添加到显示列表
        Ctpitem.value.push(`${key} : ${ctp[key]}`)
        sum += ctpValue
      }
    }
    
    // 如果有无效项，标记为缺失数据
    if(hasInvalidCtp){
      computedCtp.value = null
    } else {
      computedCtp.value = sum
    }
  }
  
  // MELD评分处理
  Melditem.value = []
  meldMissing.value = []
  
  // 固定的3个MELD指标
  const meldKeys = ['总胆红素', 'INR', '血肌酐']
  
  let meldData = model.fields['计划外' + date.value]?.meld
  let hasInvalidMeld = false
  
  // 检查 meld 对象是否存在
  if(!meldData || Object.keys(meldData).length === 0){
    computedMeld.value = null
    // 完全无数据时，每一项都显示"无效数据(由于缺项无法计算当前评分)"
    for (const key of meldKeys) {
      meldMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
    }
  } else {
    // MELD对象存在，按固定顺序处理3个指标
    for (const key of meldKeys) {
      // 检查该指标是否存在
      if (meldData[key] === undefined) {
        // 不存在的指标显示无效数据
        meldMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
        hasInvalidMeld = true
        continue
      }
      
      // 检查是否为有效数字
      let meldValue = meldData[key]
      if(typeof meldValue === 'string' && (meldValue.includes('缺') || meldValue.includes('无效') || meldValue.includes('错误'))){
        // 如果是错误信息字符串
        hasInvalidMeld = true
        meldMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
      } else if(!isFinite(Number(meldValue)) || isNaN(Number(meldValue))) {
        // 无法转换为有效数字
        hasInvalidMeld = true
        meldMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
      } else {
        // 有效数据，添加到显示列表
        Melditem.value.push(`${key} : ${meldValue}`)
      }
    }
    
    // 检查计算结果
    let value = meldData.value
    if (value && isFinite(value) && !isNaN(value)) {
      computedMeld.value = Math.floor(value)
    } else {
      computedMeld.value = null
      hasInvalidMeld = true
    }
  }
  
  // 保留原有的missKey用于兼容性（如果其他地方还在使用）
  missKey.value = model.fields['计划外' + date.value]?.meld?.missKey || []
}




const screen = reactive({
  size :80,
  rowWidth : '',
  colsapn :'',
  labelWidth : ''
})


//  根据屏幕的大小设置弹窗和表格的大小
const watchWindowSize = ()=>{

// 获取窗口的宽度和高度，不包括滚动条
var w = document.documentElement.clientWidth;
var h = document.documentElement.clientHeight;
// 打印结果
// result.innerHTML = "宽: " + w + ", " + "高: " + h

if (w > 1000) {
  // 弹窗的宽度设置80% 否则100%
  screen.size = 80
  screen.rowWidth = 100
  screen.colsapn= 15
  screen.labelWidth = 250
}else{
  screen.size = 100
  screen.rowWidth = 120
  screen.colsapn = 24
  screen.labelWidth = 160
}

}
window.onresize = ()=>{
  // watchWindowSize()

}
// 窗口变化事件
window.onload = ()=>{
// watchWindowSize()
};
;

</script>
<template>
<!-- <el-drawer v-model="drawerShow" :title="`计划外（${date}）`"
             :close-on-click-modal="false" :close-on-press-escape="false" 
             @close="handleCloseDrawer" direction="rtl" size="80%" 
             @open="handleOpenDrawer"
             class="box"> -->
             <p class="pp">{{ crfFormIndex == 2? '如果筛选期和基线间隔<14天，筛选期数据可以作为基线数据使用，请点击适用筛选期数据':'' }}</p>
             <p class="pp">{{ props.tip? `说明:肝穿后${props.tip}周（或${props.tip}周内最接近的一次）`:'' }}</p>

    <el-row v-loading.fullscreen.lock="crfLoading" element-loading-text="信息提交中" >
      <el-col :span="screen.colsapn">
        <section>
          <el-form  :model="model" size="default" label-position="left" :label-width="`${screen.labelWidth}px`" ref="formRef"
                   :rules="formRule" :scroll-to-error="true"
                   :scroll-into-view-options="{ behavior: 'smooth', block: 'start', inline: 'nearest' }">
             <!-- 适用筛选期数据 -->
             <!-- <div v-if="crfFormIndex == 3">
              <button @click.prevent="btn(true)"> 适用筛选期数据</button>
              <button @click.prevent="btn(false)" style="margin-left: 20px;">不适用筛选期数据</button>
            </div> -->
            <template v-if="componentsShow">
               
            <!-- 一般信息 -->
            <YBXX ref="IdCard"
              v-if="crf.module.includes('YBXX') && !crf.module.includes('InclusionCriteria') && !crf.module.includes('ExcludeCriteria')"
              :mode="'whole'" :formModel="model" :fold="false" :foldbuttom="true" @phones="submitForm()"></YBXX>

            <!-- 一般信息（只读）-->
            <YBXX ref="IdCard"
              v-if="crf.module.includes('YBXX') && (crf.module.includes('InclusionCriteria') || crf.module.includes('ExcludeCriteria'))"
              :mode="'part'" :readonly="true" :formModel="model"></YBXX>

            <!-- 访视信息 -->
            <div class="picker">
                <!-- <FSXX v-if="crf.module.includes('FSXX')" :formModel="model" :type="props.type"></FSXX> -->
                <el-date-picker v-model="date"
                      type="date" placeholder="选择访视日期"
                      value-format="YYYY-MM-DD" />
                      请先选择访视时间
            </div>
           
            <!-- 病史 -->
            <BS v-if="crf.module.includes('BS')" :formModel="model" :type="type" index="1" :btnshow="''"></BS>
           
            <!-- 体格检查 -->
            <!-- <TGJC v-if="crf.module.includes('TGJC')" :formModel="model" :type="props.type"></TGJC> -->

            <!-- 其他伴随治疗 -->
            <!-- <QTBSZL v-if="crf.module.includes('QTBSZL')" :formModel="model" :type="props.type"></QTBSZL> -->
                     
              <!-- 现在只有访视期v1（首次发病点） 有既往伴随治疗 -->
              <h2>既往治疗</h2>

              <!-- <h2 v-if="crfFormIndex == 2">既往治疗</h2>
              <h2 v-else-if="crfFormIndex == 3 && !btnshow">筛选期至V0期治疗补充</h2>
              <h2 v-if="crfFormIndex > 3">V{{ crfFormIndex - 4 }}期至V{{ crfFormIndex - 3 }}期治疗补充</h2> -->
            
            
                <!-- 既往TIPS治疗 （既往门脉高压介入治疗）-->
                <JWTIPSZL v-if="crf.module.includes('JWTIPSZL')" :formModel="model" title="门脉高压介入治疗"
                          :type="type"></JWTIPSZL>

                <!-- 既往外科手术治疗改：既往脾切除手术 -->
                <JWWKSSZL v-if="crf.module.includes('JWWKSSZL')" :formModel="model"
                          prefix="【脾切除手术治疗】" :type="type"></JWWKSSZL>

                <!-- 既往内镜治疗 -->
                <JWNJZL v-if="crf.module.includes('JWNJZL')" :formModel="model" 
                        :type="type"></JWNJZL>

                <!-- 既往药物治疗改：既往门脉高压药物治疗 -->
                <JWYWZL v-if="crf.module.includes('JWYWZL')" :formModel="model" prefix="【门脉高压药物治疗】"
                        :type="type"></JWYWZL>

                <!-- 肝脏失代偿（改成PSVD并发症）（门高压并发症） -->
                <!-- <GZSDC v-if="crf.module.includes('GZSDC')" :formModel="model" prefix="【门高压并发症】"
                        :type="type"></GZSDC> -->

            <p v-if="crf.module.includes('XCGJNCG')" class="tishi">实验室检查开始，未做的检查请填写"ND"</p>
            <!-- 血常规及尿常规 -->
            <XCGJNCG v-if="crf.module.includes('XCGJNCG')" :formModel="model" :type="type"></XCGJNCG>

            <!-- 凝血功能 -->
            <NXGN v-if="crf.module.includes('NXGN')" :formModel="model" :type="type"></NXGN>

            <!-- 血生化检查 -->
            <XSHJC v-if="crf.module.includes('XSHJC')" :formModel="model" :type="type"></XSHJC>

            <!-- AFP -->
            <AFP v-if="crf.module.includes('AFP')" :formModel="model" :type="type"></AFP>

            <!-- 乙肝 -->
            <YGHCVHIV v-if="crf.module.includes('YGHCVHIV')" :formModel="model" :type="type"></YGHCVHIV>

            <!-- 自身免疫性肝病抗体谱 -->
            <ANAANCA v-if="crf.module.includes('ANAANCA')" :formModel="model" :type="type"></ANAANCA>

            <!-- 免疫球蛋白定量 -->
            <MYQDB v-if="crf.module.includes('MYQDB')" :formModel="model" :type="type"></MYQDB>

            <!-- 甲状腺功能 -->
            <JZXGN v-if="crf.module.includes('JZXGN')" :formModel="model" :type="type"></JZXGN>

            <!-- 心电图 -->
            <XDT ref="xdt" v-if="crf.module.includes('XDT')" :formModel="model" :type="type"></XDT>

            <!-- 胃镜 -->
            <WJ v-if="crf.module.includes('WJ')" :formModel="model" :type="type"></WJ>

            <!-- Fibroscan -->
            <FIBROSCAN v-if="crf.module.includes('FIBROSCAN')" :formModel="model" :type="type"></FIBROSCAN>

             <!-- FIBROTOUCH -->
            <FIBROTOUCH v-if="crf.module.includes('FIBROTOUCH')" :formModel="model" :type="type"></FIBROTOUCH>

            <!-- 腹部、腹水及门静脉B超 -->
            <FBFSMJMBC v-if="crf.module.includes('FBFSMJMBC')" :formModel="model" :type="type"></FBFSMJMBC>

            <!-- 肺部CT平扫（可选） -->
            <FBCT v-if="crf.module.includes('FBCT')" :formModel="model" :type="type"></FBCT>

            <!-- 门静脉CTV -->
            <MJMCTV v-if="crf.module.includes('MJMCTV')" :formModel="model" :type="type"></MJMCTV>

            <!-- 肝脏增强CT -->
            <GZZQCT v-if="crf.module.includes('GZZQCT')" :formModel="model" :type="type"></GZZQCT>

            <!-- 肝脏增强MR -->
            <GZZQMR v-if="crf.module.includes('GZZQMR')" :formModel="model" :type="type"></GZZQMR>

            <!-- MRCP（可选） -->
            <MRCP v-if="crf.module.includes('MRCP')" :formModel="model" :type="type"></MRCP>

            <!-- HVPG测定（可选） -->
            <HVPGCD v-if="crf.module.includes('HVPGCD')" :formModel="model" :type="type"></HVPGCD>
              
            <!-- 病理报告 -->
            <BLBG v-if="crf.module.includes('BLBG')" :formModel="model" :type="type" :jhw="true"></BLBG>

            <!-- 全外显子基因测序（可选）改为基因测序 -->
            <QWXZJYCX v-if="crf.module.includes('QWXZJYCX')" :formModel="model" :type="type"></QWXZJYCX>

            <!--不良事件记录-->
            <BLSJJL v-if="crf.module.includes('BLSJJL')" :formModel="model" :type="type"></BLSJJL>

            <div style="margin-top: 20px;">
              <p @click="isctpshow = !isctpshow" class="ctpstyle">CTP评分：{{ computedCtp !== null ? computedCtp : '缺失数据' }}</p>
              <p @click="ismeldshow = !ismeldshow" class="ctpstyle">MELD评分：{{ computedMeld !== null ? computedMeld : '缺失数据' }}</p>
            </div>
            <!-- 备份血样（可选） -->
            <BFXY v-if="crf.module.includes('BFXY')" :formModel="model" :type="type"></BFXY>

            </template>
                    
          </el-form>
        </section> 
        
      </el-col>
    </el-row>
    <div style="position: absolute;bottom: 30px;right: 18px">
        <el-button @click="handleCloseDrawer">取消</el-button>
        <el-button type="primary" @click="Staging(formRef)">暂存本表单数据</el-button>
        <el-button type="primary" @click="submitForm()">完成并保存本次数据填入</el-button>
    </div>
    <!-- <template #footer>
      <el-button type="primary" @click="Staging(formRef)">暂存</el-button>
      <el-button @click="handleCloseDrawer">取消</el-button>
      <el-button type="primary" @click="submitForm(formRef,false)">确定</el-button>
    </template> -->
  <!-- </el-drawer> -->
  <el-dialog v-model="isctpshow" title="CTP" :width="`${40}%`" center>
        <div class="ctptxt">
          <!-- 显示有效的CTP项 -->
          <p v-for="(item, index) in Ctpitem" :key="index">{{ item }}</p>
          <!-- 显示缺失或无效的项 -->
          <p v-for="(item, index) in ctpMissing" :key="'miss-' + index">{{ item }}</p>
        </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="isctpshow = false">取消</el-button>
          <el-button type="primary" @click="isctpshow = false">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
    
    <el-dialog v-model="ismeldshow" title="MELD" :width="`${40}%`" center>
        <div class="ctptxt">
          <!-- 显示有效的MELD项 -->
          <p v-for="(item, index) in Melditem" :key="index">{{ item }}</p>
          <!-- 显示缺失或无效的项 -->
          <p v-for="(item, index) in meldMissing" :key="'miss-' + index">{{ item }}</p>
        </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="ismeldshow = false">取消</el-button>
          <el-button type="primary" @click="ismeldshow = false">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
</template>
<style lang="scss" scoped>
.ctpstyle{
  display: block;
  font-size: 22px;
  cursor: pointer;
  text-decoration: underline;
}
.ctptxt{
  font-size: 18px;
}
.picker{
    position:fixed;
    top:15px;
    /* left: 270px; */
    left: 655px;

}
@media screen and (max-width:1200px ) {
  .picker{
    position:fixed;
    top:60px;
    /* left: 270px; */
    left: 15px;
    z-index: 100;
    background-color: white;

  }
}


.tishi{
      font-size: 16px;
      color: rgb(240, 102, 102);
      /* padding-left: 15px; */
      margin: 0;
    }
</style>